const DS_API_BASE_PATH = '/hcem/ui'

export type ElectricityPriceParams = {
  plantId: string
  from: string
  to: string
}

export type PeakLoadWindowsParams = {
  plantId: string
  from: string
  to: string
}

export const getElectricityPricePath = (plantId: string): string =>
  `${DS_API_BASE_PATH}/electricity/${plantId}`

export const getPeakLoadWindowsPath = (plantId: string): string =>
  `${DS_API_BASE_PATH}/peak_load_windows/${plantId}`
